import { render, staticRenderFns } from "./messages-icon.vue?vue&type=template&id=5484a3c4&scoped=true&"
import script from "./messages-icon.vue?vue&type=script&lang=ts&"
export * from "./messages-icon.vue?vue&type=script&lang=ts&"
import style0 from "./messages-icon.vue?vue&type=style&index=0&id=5484a3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484a3c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5484a3c4')) {
      api.createRecord('5484a3c4', component.options)
    } else {
      api.reload('5484a3c4', component.options)
    }
    module.hot.accept("./messages-icon.vue?vue&type=template&id=5484a3c4&scoped=true&", function () {
      api.rerender('5484a3c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/partial/messages-icon.vue"
export default component.exports